import HttpService from "@/services/HttpService";
import Swal from "sweetalert2";
import Auth from "../Auth";
class WishlistService {
  async getWishlist() {
    return HttpService.get("/wishlist", "", true);
  }

  async addToWishlist(productId) {
    if (Auth.authenticated()) {
      return HttpService.post("/wishlist", { product_id: productId }, true);
    }
  }

  async removeFromWishlist(productId) {
    return HttpService.delete(`/wishlist/${productId}`, true);
  }

  async clearWishlist() {
    return HttpService.delete("/wishlist", true);
  }
}

export default new WishlistService();
